import { useEffect } from 'react'
import { Redirect, Route, useLocation } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import {
    IonApp,
    IonIcon,
    IonLabel,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
    IonBadge,
} from '@ionic/react'
import { IonReactHashRouter } from '@ionic/react-router'
import { home, grid, cart, person } from 'ionicons/icons'

import { useCartTotal } from '../graphql/client'
import { CHECKOUT_CUSTOMER_ASSOCIATE, CREATE_CHECKOUT } from '../graphql/mutations'
import { storage } from '../utils/index'

// routes
import Home from '../modules/Home'
import Category from '../modules/Category'
import Cart from '../modules/Cart'
import User from '../modules/User'
import Register from '../modules/Register'
import Login from '../modules/Login'
import Order from '../modules/Order'
import Search from '../modules/Search'
import Reset from '../modules/Reset'
import Address from '../modules/Address'
import Detail from '../modules/Detail'
import Privacy from '../modules/Privacy'
import Promotion from '../modules/Promotion'

const routes = [
    {
        path: '/home',
        Component: Home,
        icon: home,
        title: 'Home',
    },

    {
        path: '/category/:handle',
        Component: Category,
        icon: grid,
        title: 'Menu',
    },
    {
        path: '/cart',
        Component: Cart,
        icon: cart,
        title: 'Cart',
    },

    {
        path: '/user',
        Component: User,
        icon: person,
        title: 'User',
    },
    {
        path: '/register',
        Component: Register,
    },
    {
        path: '/login',
        Component: Login,
    },
    {
        path: '/address',
        Component: Address,
    },
    {
        path: '/order',
        Component: Order,
    },
    {
        path: '/reset',
        Component: Reset,
    },
    {
        path: '/detail/:handle',
        Component: Detail,
    },
    {
        path: '/privacy',
        Component: Privacy,
    },
    {
        path: '/search',
        Component: Search,
    },
    {
        path: '/promotion/:handle',
        Component: Promotion,
    },
]

const tabs = routes.slice(0, 4)

const App = () => {
    const total = useCartTotal()

    const [associate] = useMutation(CHECKOUT_CUSTOMER_ASSOCIATE)
    const accessToken = storage.getItem('accessToken')
    const [mutate] = useMutation(CREATE_CHECKOUT, {
        update(cache, { data }) {
            if (data?.checkoutCreate?.checkout) {
                storage.setItem('checkout', data.checkoutCreate.checkout)
                if (accessToken) {
                    associate({
                        variables: {
                            checkoutId: data?.checkoutCreate?.checkout.id,
                            customerAccessToken: accessToken,
                        },
                    })
                }
            }
        },
    })

    useEffect(() => {
        const checkout = storage.getItem('checkout')
        if (!checkout || !checkout.id) {
            mutate({
                variables: {
                    input: {},
                },
            })
        }
    }, [])

    return (
        <IonApp>
            <IonReactHashRouter>
                <IonTabs>
                    <IonRouterOutlet>
                        {routes.map((item) => (
                            <Route path={item.path} exact>
                                <item.Component />
                            </Route>
                        ))}
                        {/* <Route
                            path="/user"
                            render={() => (
                                <IonTabs>
                                    <IonRouterOutlet>
                                        
                                    </IonRouterOutlet>
                                    <IonTabBar slot="bottom"></IonTabBar>
                                </IonTabs>
                            )}
                        ></Route> */}

                        <Route exact path="/">
                            <Redirect to="/home" />
                        </Route>
                    </IonRouterOutlet>
                    <IonTabBar slot="bottom">
                        {tabs.map((tab) => (
                            <IonTabButton tab={tab.title} href={tab.path} key={tab.path}>
                                <IonIcon icon={tab.icon} />
                                <IonLabel>{tab.title.toUpperCase()}</IonLabel>
                                {Boolean(tab.path === '/cart' && total) && (
                                    <IonBadge>{total}</IonBadge>
                                )}
                            </IonTabButton>
                        ))}
                    </IonTabBar>
                </IonTabs>
            </IonReactHashRouter>
        </IonApp>
    )
}

export default App
